import { Breadcrumb } from '@components/breadcrumb';
import { PageContainers } from '@components/page-containers';

import { useCompanyInfo } from 'api/companies/hooks';
import { Header } from 'components/headers';
import { Loading } from 'components/Loading';
import { PageContent } from 'components/Page';
import { SettingsSection } from 'components/settings-section';
import { useStore } from 'models/Provider';

import { CareerBanner } from './career-banner';
import { CareerLogo } from './career-logo';

export const CareerTheme = () => {
  const { t } = useStore();

  const companyQuery = useCompanyInfo();

  if (!companyQuery.data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        breadcrumbs={<Breadcrumb items={[{ label: t('company.settings.career.theme.header') }]} />}
      />
      <PageContent>
        <PageContainers.MiddleColumnPage>
          <SettingsSection description={t('company.settings.career.theme.description')}>
            <CareerLogo companyInfo={companyQuery.data} />
            <CareerBanner companyInfo={companyQuery.data} />
          </SettingsSection>
        </PageContainers.MiddleColumnPage>
      </PageContent>
    </>
  );
};
